<section class="content">
  <div class="content-block">

    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'EVENTOS' }]">
      </app-breadcrumb>
    </div>

    <app-top-widgets></app-top-widgets>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">

          <!-- ========================================================= -->
          <!-- ✅ FILTRO TUTOR (APARTE, COMO EN LISTA DE RECETAS) -->
          <!-- ========================================================= -->
          @if (showTutorSelect) {
            <div class="content-block">
              <div class="row m-2 align-items-start">
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>VER EVENTOS DE (OPCIONAL)</mat-label>

                    <mat-select
                      [(ngModel)]="selectedPacienteId"
                      (selectionChange)="onTutorPacienteChange()">

                      <!-- null = token mode -->
                      <mat-option [value]="null">MI PERFIL (POR DEFECTO)</mat-option>

                      @for (p of tutorPacientes; track p.idPaciente) {
                        <mat-option [value]="p.idPaciente">
                          <div class="tutor-option">
                            <div class="avatar">
                              @if (p.imagenSrc) {
                                <img [src]="p.imagenSrc" alt="IMG" />
                              } @else {
                                <span class="initials">{{ p.initials }}</span>
                              }
                            </div>

                            <div class="info">
                              <div class="name">{{ p.nombreCompleto }}</div>
                            </div>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          }

          <!-- ========================================================= -->
          <!-- ✅ HEADER ORIGINAL (SIN CAMBIOS) -->
          <!-- ========================================================= -->
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-search-box">
                  <label><i class="material-icons search-icon">search</i></label>
                  <input
                    #filter
                    aria-autocomplete="none"
                    aria-label="Search box"
                    autocomplete="nope"
                    class="browser-default search-field"
                    placeholder="BUSCAR"
                    type="text" data-tour="evt-search">
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="CREAR">
                    <button (click)="addNew()" color="primary" mat-mini-fab data-tour="evt-create">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </li>
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="RECARGAR">
                    <button (click)="refresh()" color="primary" mat-mini-fab data-tour="evt-refresh">
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                </li>
                @if (!isPatient) {
                  <li>
                    <div class="export-button m-l-10" matTooltip="EXCEL">
                      <img (click)="exportExcel()" alt="" height="512" ngSrc="assets/images/icons/xlsx.png"
                           width="512"/>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>

          <!-- ========================================================= -->
          <!-- ✅ TABLA ORIGINAL (SIN CAMBIOS) -->
          <!-- ========================================================= -->
          <div class="body overflow-auto">
            <div class="responsive_table">
              <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

                <ng-container matColumnDef="idPaciente">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.idEvento}}">{{ row.idEvento }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="evento">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.nombreEvento}}">
                    <span class="mobile-label">Nombre:</span>{{ row.nombreEvento }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="fecha">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>FECHA</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.fecha}}">
                    <span class="mobile-label">Fecha:</span>{{ row.fecha }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="descripcion">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPCION</mat-header-cell>

                  <mat-cell *matCellDef="let row" class="pr-0">
                    <span class="mobile-label">DESCRIPCION:</span>

                    <div class="desc-cell">
                      <div class="desc-text" [class.expanded]="isDescExpanded(row)">
                        {{ row.descripcion || 'SIN DESCRIPCION' }}
                      </div>

                      @if (shouldShowToggle(row.descripcion)) {
                        <button
                          type="button"
                          class="desc-toggle"
                          (click)="$event.stopPropagation(); toggleDesc(row)">
                          {{ isDescExpanded(row) ? 'LEER MENOS' : 'LEER MAS' }}
                        </button>
                      }
                    </div>
                  </mat-cell>
                </ng-container>

                <!-- actions -->
                <ng-container matColumnDef="acciones">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                    <button (click)="$event.stopPropagation(); editCall(row) " class="tbl-action-btn"
                            mat-icon-button data-tour="evt-edit">
                      <app-feather-icons [class]="'tbl-fav-edit'" [icon]="'edit'"></app-feather-icons>
                    </button>
                    <button (click)="$event.stopPropagation(); deleteItem(row)"
                            class="tbl-action-btn" mat-icon-button data-tour="evt-delete">
                      <app-feather-icons [class]="'tbl-fav-delete'" [icon]="'trash-2'"></app-feather-icons>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
              </table>

              <!-- Loading spinner -->
              @if (data?.isTblLoading) {
                <div class="tbl-spinner">
                  <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                  </mat-progress-spinner>
                </div>
              }

              @if (!data?.isTblLoading) {
                <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                  SIN RESULTADOS
                </div>
              }

              <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             [pageSize]="10">
              </mat-paginator>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</section>
